import { render, staticRenderFns } from "./DecreeZoneList.vue?vue&type=template&id=09ca50a4"
import script from "./DecreeZoneList.vue?vue&type=script&lang=js"
export * from "./DecreeZoneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports